import React from "react"
import {Customer} from "../../services/customer/Customer"
import {makeStyles} from "tss-react/mui"
import {Paper, Table, TableHead, TableRow, TableCell, TableBody, Container} from "@mui/material"
//import history from "../../utils/history"
import {navigateTo} from "../../utils/navigotor"

const useStyles = makeStyles()({
	root: {
		width: "100%",
		marginTop: "15px",
		overflowX: "auto",
	},
	table: {
		minWidth: 650,
	},
})

interface Props {
	customers: Array<Customer>
	orderNumber?: string
}

const handleClick = (id: string, orderNumber?: string) => {
	const tenantId = new URLSearchParams(window.location.search).get("tenantId")
	const query = new URLSearchParams({shopper_id: id})

	if (tenantId) {
		query.set("tenantId", tenantId)
	}
	navigateTo(`/orders/${orderNumber || ""}?${query.toString()}`)
}

export default function SearchResults(props: Props) {
	const {classes} = useStyles()
	const {customers} = props

	return (
		<Container maxWidth={false}>
			<Paper className={classes.root}>
				<Table className={classes.table}>
					<TableHead>
						<TableRow>
							<TableCell>First Name</TableCell>
							<TableCell>Last Name</TableCell>
							<TableCell>Email Addresss</TableCell>
							<TableCell>Account ID</TableCell>
							{/* <TableCell >Select</TableCell> */}
						</TableRow>
					</TableHead>
					<TableBody>
						{customers.map((customer) => (
							<SearchItem
								key={customer.customer.emailAddress}
								customer={customer}
								orderNumber={props.orderNumber}
							/>
						))}
					</TableBody>
				</Table>
			</Paper>
		</Container>
	)
}

interface SIProps {
	key: string
	customer: Customer
	orderNumber?: string
}

// Todo: ask Mr Webb about not rerendering each time customer loads
function SearchItem(props: SIProps) {
	return (
		<TableRow
			hover
			key={props.customer.customer.emailAddress}
			onClick={() => handleClick(props.customer.id, props.orderNumber)}
		>
			<TableCell component="th" scope="row">
				{props.customer.customer.firstName}
			</TableCell>
			<TableCell>{props.customer.customer.lastName}</TableCell>
			<TableCell>{props.customer.customer.emailAddress}</TableCell>
			<TableCell>{props.customer.id}</TableCell>
		</TableRow>
	)
}
